(() => {
  if (customElements.get('packsys-bar-volume')) return;
  class PacksysBarVolume extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-bar-config]').textContent);
      this.input = this.querySelector('[data-bar-input]');
      this.form = document.getElementById(this.dataset.form);
      this.minus = this.querySelector('[data-bar-minus]');
      this.plus = this.querySelector('[data-bar-plus]');
      this.error = this.querySelector('[data-bar-error]');
      this.money = new Intl.NumberFormat(this.config.locale === 'es' ? 'es-MX' : (this.config.locale || 'es-MX'), { style:'currency', currency:this.config.currency });
      this.minus.addEventListener('click', () => this.step(-1));
      this.plus.addEventListener('click', () => this.step(1));
      this.input.addEventListener('input', () => this.render());
      this.input.addEventListener('change', () => this.normalize());
      this.input.addEventListener('blur', () => this.normalize());
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); this.normalize(); }
      });
      this.form?.addEventListener('submit', event => {
        this.render();
        if (!this.valid || !this.config.available) {
          event.preventDefault(); event.stopImmediatePropagation(); this.input.focus();
        }
      }, true);
      this.render();
    }
    step(direction) {
      const { min, step, max } = this.config;
      const current = Number(this.input.value);
      const next = Math.max(min, (Number.isFinite(current) ? current : min) + direction * step);
      this.input.value = max == null ? next : Math.min(max, next);
      this.input.dispatchEvent(new Event('change', { bubbles:true }));
    }
    normalize() {
      const { min, step, max } = this.config;
      let q = Number(this.input.value);
      if (!Number.isFinite(q) || this.input.value.trim() === '') q = min;
      q = Math.max(min, min + Math.round((q - min) / step) * step);
      if (max != null && q > max) q = min + Math.floor((max - min) / step) * step;
      this.input.value = q;
      this.render();
    }
    render() {
      const c = this.config;
      const q = Number(this.input.value);
      const numericValid = this.input.value.trim() !== '' && Number.isSafeInteger(q) && q >= c.min && (q - c.min) % c.step === 0;
      const exceedsRule = c.max != null && q > c.max;
      const exceedsStock = c.available && c.tracked && q + c.cartQty > c.inventory;
      this.valid = numericValid && !exceedsRule && !exceedsStock;
      const error = !numericValid ? c.labels.invalid : exceedsRule || exceedsStock ? c.labels.limit : '';
      this.error.textContent = error;
      this.error.hidden = !error;
      this.input.setAttribute('aria-invalid', String(!!error));
      this.minus.disabled = !numericValid || q <= c.min;
      this.plus.disabled = !numericValid || (c.max != null && q >= c.max);
      const add = this.form?.querySelector('[name="add"]');
      if (add && !add.classList.contains('loading')) add.disabled = !this.valid || !c.available;
      let tierIndex = 0;
      let percent = 0;
      c.tiers.forEach((tier, index) => {
        if (q >= tier.min) { tierIndex = index + 1; if (c.discountsActive || c.discountsPreview) percent = tier.percent; }
      });
      this.querySelectorAll('[data-bar-tier]').forEach((card, index) => {
        if (numericValid && index === tierIndex) card.setAttribute('aria-current', 'step');
        else card.removeAttribute('aria-current');
      });
      const format = cents => this.money.format(cents / 100);
      const gross = numericValid ? c.price * q : 0;
      const saving = Math.round(gross * percent / 100);
      const total = gross - saving;
      this.querySelector('[data-bar-count]').textContent = numericValid ? `${q} ${q === 1 ? c.labels.piece : c.labels.pieces}` : '—';
      this.querySelector('[data-bar-total]').textContent = numericValid ? format(total) : '—';
      this.querySelector('[data-bar-unit]').textContent = numericValid ? format(total / q) : '—';
      this.querySelector('[data-bar-saving-row]').hidden = !numericValid || saving === 0;
      this.querySelector('[data-bar-saving]').textContent = format(saving);
    }
  }
  customElements.define('packsys-bar-volume', PacksysBarVolume);
})();
